/*
 * @providesModule BankWithdrawalSuccessModal
 */

import {Text, StyleSheet} from 'react-native';
import React from 'react';
import {customModalStyles} from './ModalStyles';
import {
  BANK_WITHDRAWAL_SUCCESS_MODAL_RTP_DEFAULTS,
  WITHDRAWAL_SUCCESS_MODAL_DEFAULTS,
} from '../BankWithdrawalConstants';
import {DialogV3} from 'DialogV3';
import SkillzImage from 'SkillzImage';
import {ModalButton} from './ModalButton';

type BankWithdrawalSuccessModalProps = {
  onDismiss: () => void;
  bodyText?: string;
  isRTPTransaction?: boolean;
};

const BankWithdrawalSuccessModal = ({
  onDismiss,
  bodyText,
  isRTPTransaction,
}: BankWithdrawalSuccessModalProps) => {
  return (
    <DialogV3
      onClose={onDismiss}
      headerContainerStyles={styles.headerContainer}
      showConfetti={true}
      headerImageComponent={
        <SkillzImage
          style={isRTPTransaction ? {width: 50, height: 60} : {width: 38.78, height: 38.78}}
          source={
            isRTPTransaction
              ? BANK_WITHDRAWAL_SUCCESS_MODAL_RTP_DEFAULTS.icon
              : WITHDRAWAL_SUCCESS_MODAL_DEFAULTS.icon
          }
          tintColor={isRTPTransaction ? '' : '#13B657'}
        />
      }
    >
      <Text style={customModalStyles.modalTitleText} allowFontScaling={false}>
        {WITHDRAWAL_SUCCESS_MODAL_DEFAULTS.title}
      </Text>
      <Text style={customModalStyles.modalBodyText} allowFontScaling={false}>
        {bodyText}
      </Text>

      <ModalButton
        text={WITHDRAWAL_SUCCESS_MODAL_DEFAULTS.buttonTextPrimary}
        buttonContainerStyle={styles.buttonContainer}
        onPress={onDismiss}
        buttonTextProps={{allowFontScaling: false}}
      />
    </DialogV3>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    paddingTop: 39,
    paddingBottom: 34.22,
  },
  buttonContainer: {
    marginTop: 50,
    marginBottom: 18,
  },
});

export default BankWithdrawalSuccessModal;
